<template>
  <v-container>
    <alert :type="alertType" @closealert="closeAlert" :alertShow="alertShow" :msg="alertMsg"></alert>

    <info
      v-if="path=='' || path=='user'"
      :readonly="!(path=='user')"
      @username="newUsername"
      @mail="newMail"
      @userid="newUserId"
      @lang="setLang"
    ></info>

    <password
      v-if="path=='password'"
      :username="username"
      @passformcheck="checkPasswordForm"
      @currentpassword="newCurrentPassword"
      @newpassword="newNewPassword"
      @currentPasscheck="checkCurrentPass"
    ></password>
    <buttons v-if="path==''" @edituser="editUser" @changePassword="changePassword"></buttons>
    <saveButton
      v-if="path!=''"
      :path="path"
      :username="username"
      :mail="mail"
      :currentPassword="currentPassword"
      :newPassword="newPassword"
      :checkForm="checkForm"
      :checkPass="checkPass"
      :userId="userId"
      @error="error"
      @saved="save"
      @back="back"
    ></saveButton>
    <br>
    <language @savelang="saveLang" @error="error" :id="userId"></language>
  </v-container>
</template>

<script>
import InfoComponent from "./Infos";
import ButtonsComponent from "./Buttons";
import SaveButtonComponent from "./SaveButton";
import PasswordComponent from "./Password";
import AlertComponent from "./Alert";
import LanguageComponent from "./Language";

import languageStore from "../../store/LanguageStore";

export default {
  components: {
    info: InfoComponent,
    buttons: ButtonsComponent,
    saveButton: SaveButtonComponent,
    password: PasswordComponent,
    alert: AlertComponent,
    language: LanguageComponent
  },
  props: {
    changedPath: String
  },
  data: () => ({
    username: "",
    mail: "",
    userId: "",
    alertShow: false,
    alertType: "error",
    alertMsg: "",
    path: "",
    currentPassword: "",
    newPassword: "",
    checkForm: null,
    checkPass: null
  }),
  watch: {
    changedPath: function(value) {
      if (value == "settings") this.back();
    }
  },
  methods: {
    setLang: function(value) {
      languageStore.setLang(value);
      this.$emit("changelang");
    },
    editUser: function() {
      this.path = "user";
      this.$emit("subpath", [
        { name: this.$t("Settings.edituser"), subpath: this.path }
      ]);
    },
    changePassword: function() {
      this.path = "password";
      this.$emit("subpath", [
        { name: this.$t("Settings.editpassword"), subpath: this.path }
      ]);
    },
    save: function(value) {
      this.path = "";
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
    },
    saveLang: function(value) {
      this.setLang(value);
      this.path = "";
      this.alertMsg = this.$t('Settings.Alert.success-lang');
      this.alertType = "success";
      this.alertShow = true;
    },
    newUsername: function(value) {
      this.username = value;
    },
    newMail: function(value) {
      this.mail = value;
    },
    newUserId: function(value) {
      this.userId = value;
    },
    error: function(value) {
      switch (value) {
        default:
          this.alertMsg = this.$t("Settings.Alert.default");
          break;
        case "username is already used":
          this.alertMsg = this.$t("Settings.Alert.username-error");
          break;
        case "mail is already used !":
          this.alertMsg = this.$t("Settings.Alert.mail-error");
          break;
        case "Incorrect password":
          this.alertMsg = this.$t("Settings.Alert.pass-error");
          break;
        case "Complete correctly the form":
          this.alertMsg = this.$t("Settings.Alert.form-error");
          break;
      }

      this.alertType = "error";
      this.alertShow = true;
    },
    back: function() {
      this.path = "";
      this.$emit("subpath", []);
    },
    newCurrentPassword: function(value) {
      this.currentPassword = value;
    },
    newNewPassword: function(value) {
      this.newPassword = value;
    },
    closeAlert: function() {
      this.alertShow = false;
    },
    checkPasswordForm: function(value) {
      this.checkForm = value;
    },
    checkCurrentPass: function(value) {
      this.checkPass = value;
    }
  }
};
</script>